import LoLQuestionContent from './LoLQuestionContent';

export default LoLQuestionContent;
